var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-row",
            { staticClass: "marginTop" },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: { label: "Tipo de cadastro:", content: _vm.tipo }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Data de cadastro:",
                      content: this.dataCadastro
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c("app-divider", { attrs: { label: "Qualificação" } }),
          _c(
            "div",
            { staticClass: "margemTop" },
            [
              _c("app-display", {
                class:
                  _vm.compararQualificacaoPermuta &&
                  _vm.compararQualificacaoPermuta.mudouPertenceAoProjeto
                    ? "text"
                    : "",
                attrs: {
                  label: "Pertence ao Projeto Integrado Trairão?",
                  content: _vm.qualificacao.pertenceAoProjeto
                    ? "Sim, " + _vm.qualificacao.gleba.nome
                    : "Não"
                }
              }),
              _c("app-display", {
                class:
                  _vm.compararQualificacaoPermuta &&
                  _vm.compararQualificacaoPermuta.mudouBeneficiarioOriginal
                    ? "text"
                    : "",
                attrs: {
                  label: "O interessado é o beneficiário original?",
                  content: _vm.qualificacao.beneficiarioOriginal ? "Sim" : "Não"
                }
              }),
              _c("app-display", {
                class:
                  _vm.compararQualificacaoPermuta &&
                  _vm.compararQualificacaoPermuta.mudouBeneficiarioOriginal
                    ? "text"
                    : "",
                attrs: {
                  label: "O Valor da Terra Nua (VTN) foi pago integralmente?",
                  content: _vm.qualificacao.beneficiarioOriginal ? "Sim" : "Não"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46800973", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46800973","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/cadastrosOnline/informacoesPermuta/InformacoesQualificacaoPermuta.vue
// module id = null
// module chunks = 